
import moment from 'moment';
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import {
  Connection,
} from '@/types';
import DatePicker from '@/components/DatePicker.vue';
import EditIterConfirmationDialog from '@/components/EditIterConfirmationDialog.vue';

moment.locale('it');

@Component({
  components: {
    DatePicker,
    EditIterConfirmationDialog,
  },
})
export default class ConnectionIterConfirmationDate extends Vue {
  @Prop(Object) readonly connection!: Connection;

  loading = false
  editDialog = false

  get isDisabled() {
    return this.loading;
  }

  get iterConfirmationDate(): Date | null {
    return this.connection?.iterConfirmationDate ?? null;
  }

  get iterConfirmationPendingDate(): Date | null {
    return this.connection?.iterConfirmationPendingDate ?? null;
  }

  get iterConfirmation(): string | null {
    return this.connection?.iterConfirmation ?? null;
  }

  get iterConfirmationDateString(): string | null {
    if (this.iterConfirmation === 'pending') {
      return this.iterConfirmationPendingDate
        && moment(this.iterConfirmationPendingDate).isValid()
        ? moment(this.iterConfirmationPendingDate).format('L')
        : null;
    }

    if (this.iterConfirmation === 'confirmed') {
      return this.iterConfirmationDate
        && moment(this.iterConfirmationDate).isValid()
        ? moment(this.iterConfirmationDate).format('L')
        : null;
    }

    return null;
  }

  get columnClass(): string {
    // Se il task è completato o in errore, colora ogni colonna rispettivamente di verde o rosso
    if (this.iterConfirmation === 'confirmed') return 'green';
    if (this.iterConfirmation === 'pending') return 'orange';
    return '';
  }

  get tooltipColor(): string {
    if (this.iterConfirmation === 'confirmed') return 'success';
    if (this.iterConfirmation === 'pending') return 'warning';
    return '';
  }

  get tooltipText(): string {
    if (this.iterConfirmation === 'confirmed') {
      return this.iterConfirmationDateString
        ? `Confermato il ${this.iterConfirmationDateString}`
        : 'Confermato (data mancante)';
    }
    if (this.iterConfirmation === 'pending') {
      return this.iterConfirmationDateString
        ? `In attesa di conferma dal ${this.iterConfirmationDateString}`
        : 'In attesa di conferma (data mancante)';
    }
    return 'Non confermato';
  }

  get displayText(): string {
    if (this.iterConfirmation === 'confirmed' && !this.iterConfirmationDateString) {
      return 'Confermato';
    }
    if (this.iterConfirmation === 'pending' && !this.iterConfirmationDateString) {
      return 'In attesa di conferma';
    }
    return this.iterConfirmationDateString || 'non confermato';
  }

  get shouldBeDisabled(): boolean {
    if ((this.iterConfirmation === 'confirmed' || this.iterConfirmation === 'pending')
        && !this.iterConfirmationDateString) {
      return false;
    }
    return !this.iterConfirmationDateString && !this.isDisabled;
  }

  async onEdit() {
    // Non permette l'apertura del dialog durante il caricamento
    if (this.loading || this.isDisabled) return;

    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    // La connessione deve esistere per procedere
    if (this.connection) {
      // Seleziona la Connection prima di aprire il dialog
      this.loading = true;
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
      this.editDialog = true;
      this.loading = false;
    }
  }
}

